import React, { useState, useEffect, useRef } from 'react';
import { FiArrowUp, FiArrowDown, FiInfo } from "react-icons/fi";
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";
import * as eidAppointmentActions from '../../Redux/Actions/eidAppointmentDetails';
import { toastMessage } from '../../utils/toast';
import { useSortableData } from '../../utils/sortableData';
import { clearSession } from '../../utils/initiate';
import { getParams, dateTimeFormat, useOnClickOutside } from '../../utils';
import {
    getPageNumber, getPageSize, getName, getPhoneNumber, getEmail, getApplicationNo, getGender, getSubmittedOn, getUuid, getJobId, getPaymentStatus,
    getClearFilterFlag, getDepartmentList, getMasterProcessList, getProcessList, reset, getAppointmentStartDate, getAppointmentEndDate, getSubmittedOnStartDate, getSubmittedOnEndDate
} from '../../Redux/Reducers/eidAppointmentFilter';
import Warning from '../Ui/400';
import ReactPaginate from 'react-paginate';
import '../../assets/table.css';
import DataCountEid from './dataCountEid';
import { Line } from 'rc-progress';
import Loader from 'react-loader-spinner';
import { Badge, Modal, Button, Form, Dropdown } from 'react-bootstrap';
import './noteModal';
import NoteModal from './noteModal';
import { FaChevronRight, FaTasks, FaFingerprint, FaEnvelope, FaStickyNote, FaEllipsisV, FaFileAlt } from 'react-icons/fa';
import { BsListTask } from 'react-icons/bs';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';


const EidAppointmentDetails = ({ history }) => {
    let itemsPerPage = 10;
    const {
        pageNumber = 1,
        pageSize = 10,
        nameCache,
        phoneNumberCache,
        emailCache,
        jobIdCache,
        applicationNoCache,
        paymentStatusCache,
        submittedOnStartDateCache,
        submittedOnEndDateCache,
        appointmentStartDateCache,
        appointmentEndDateCache,
        clearFilterFlag = 0,
    } = useSelector((state) => state.eidAppointmentFilter || {});
    const [data, setData] = useState([]);
    const [type, setType] = useState('');
    const [statusList, setStatusList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errStatus, setErrStatus] = useState(200);
    const dispatch = useDispatch();
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [pageNo, setPageNo] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const { t } = useTranslation();

    let params = getParams(window.location.search);
    let groupStatus = params.groupStatus;
    let countType = params.countType;
    const [popupNoteID, setPopupNoteID] = useState('');
    const [isReadMore, setIsReadMore] = useState(true);
    const ref = useRef();
    const userData = useSelector(({ User }) => User.data);
    const { items, requestSort, sortConfig } = useSortableData(data);
    useOnClickOutside(ref, () => handleNotePopupClose());
    const [progressBarValue, setProgressBarValue] = useState(50);
    const [jobStatusMultipleOptions, setJobStatusMultipleOptions] = useState([]);
    const [name, setName] = useState(nameCache || '');
    const [phoneNumber, setPhoneNumber] = useState(phoneNumberCache || '');
    const [email, setEmail] = useState(emailCache || '');
    const [applicationNo, setApplicationNo] = useState(applicationNoCache || '');
    const [gender, setGender] = useState('');
    const [submittedOn, setSubmittedOn] = useState('');
    const [uuid, setUuid] = useState('');
    const [jobId, setJobId] = useState(jobIdCache || null);
    const [paymentStatus, setPaymentStatus] = useState(paymentStatusCache || '');
    const [filterName, setFilterName] = useState('');
    const [filterPhoneNumber, setFilterPhoneNumber] = useState('');
    const [filterEmail, setFilterEmail] = useState('');
    const [filterApplicationNo, setFilterApplicationNo] = useState('');
    const [filterPaymentStatus, setFilterPaymentStatus] = useState('');
    const [filterJobId, setFilterJobId] = useState(null);
    const [filterSubmittedOnStartDate, setFilterSubmittedOnStartDate] = useState('');
    const [filterSubmittedOnEndDate, setFilterSubmittedOnEndDate] = useState('');
    const [filterAppointmentStartDate, setFilterAppointmentStartDate] = useState('');
    const [filterAppointmentEndDate, setFilterAppointmentEndDate] = useState('');
    const [loadingCsv, setLoadingCsv] = useState(false);
    const [biometricStatus, setBiometricStatus] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [selectedBiometricId, setSelectedBiometricId] = useState(null);
    const [paymentLinkLoaderId, setPaymentLinkLoaderId] = useState(null);
    const [showNoteModal, setShowNoteModal] = useState(false);
    const [selectedNoteId, setSelectedNoteId] = useState(null);
    const [showBiometricConfirmModal, setShowBiometricConfirmModal] = useState(false);
    const [showPaymentConfirmModal, setShowPaymentConfirmModal] = useState(false);
    const [selectedPaymentId, setSelectedPaymentId] = useState("");
    const [isAlterMail, setIsAlterMail] = useState(false);
    const [alterMail, setAlterMail] = useState("");
    const [rowMail, setRowMail] = useState("");
    const [submittedOnStartDate, setSubmittedOnStartDate] = useState(submittedOnStartDateCache || "");
    const [submittedOnEndDate, setSubmittedOnEndDate] = useState(submittedOnEndDateCache || "");
    const [appointmentStartDate, setAppointmentStartDate] = useState(appointmentStartDateCache || "");
    const [appointmentEndDate, setAppointmentEndDate] = useState(appointmentEndDateCache || "");

    const [showBiometricReceiptMailModal, setShowBiometricReceiptMailModal] = useState(false);
    const [selectedApplicationNo, setSelectedApplicationNo] = useState(null);
    const [selectedEmail, setSelectedEmail] = useState("");
    const [selectedJobId, setSelectedJobId] = useState(null);
    const [isAlterMailReceipt, setIsAlterMailReceipt] = useState(false);
    const [alterMailReceipt, setAlterMailReceipt] = useState("");
    const [loadingReceiptMail, setLoadingReceiptMail] = useState(false);
    const [loadingReceiptDownload, setLoadingReceiptDownload] = useState(false);
    const [receiptMailSuccess, setReceiptMailSuccess] = useState(false);
    const [receiptMailError, setReceiptMailError] = useState(false);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setProgressBarValue((prev) => {
                if (prev >= 90) {
                    clearInterval(intervalId);
                    return 97;
                } else {
                    return prev + 10;
                }
            });
        }, 1000);
        return () => clearInterval(intervalId);
    }, []);


    useEffect(() => {
        handleGetAllEidAppointment();
    }, [pageNo, pageSize]);

    useEffect(() => {
        setFilterName(nameCache);
        setFilterPhoneNumber(phoneNumberCache);
        setFilterEmail(emailCache);
        setFilterJobId(jobIdCache);
        setFilterApplicationNo(applicationNoCache);
        setFilterPaymentStatus(paymentStatusCache);
        setFilterSubmittedOnStartDate(submittedOnStartDateCache);
        setFilterSubmittedOnEndDate(submittedOnEndDateCache);
        setFilterAppointmentStartDate(appointmentStartDateCache);
        setFilterAppointmentEndDate(appointmentEndDateCache);
    }, [])
    const handleGetAllEidAppointment = () => {
        setLoading(true);

        let payload = {
            pageNumber: pageNo,
            pageSize: itemsPerPage,
            name: name || '',
            phoneNumber: phoneNumber || '',
            email: email || '',
            applicationNo: applicationNo || '',
            gender: gender || '',
            submittedOn: submittedOn || '',
            uuid: uuid || '',
            paymentStatus: paymentStatus ? paymentStatus : '',
            jobId: jobId || null,
            appointmentStartDate: appointmentStartDate || '',
            appointmentEndDate: appointmentEndDate || '',
            submittedOnStartDate: submittedOnStartDate || '',
            submittedOnEndDate: submittedOnEndDate || '',
        };
        eidAppointmentActions.getAllEidAppoinment(payload).then(res => {
            if (res && res.data) {
                setTotalRecords(res?.data?.totalRecords);

                let eidAppointmentData = res.data.data.map((form, index) => ({
                    sno: (pageNo - 1) * itemsPerPage + index + 1,
                    id: form.id,
                    name: form.name,
                    phoneNumber: form.phoneNumber,
                    email: form.email,
                    applicationNo: form.applicationNo,
                    gender: form.gender,
                    submittedOn: form.submittedOn,
                    uuid: form.uuid,
                    paymentStatus: form.payment?.status ?? "-",
                    paymentCompletedDate: form.payment?.completedDate ?? "-",
                    biometricAppointmentDate: form.biometricAppointment?.appointmentDateTime ?? "-",
                    biometricAppointmentStatus: form.biometricAppointment?.status ?? "-",
                    biometricId: form.biometricAppointment?.id ?? "",
                    biometricAppointment: form.biometricAppointment ?? null,
                    jobId: form?.jobId ?? null
                }));
                setData(eidAppointmentData);
                setProgressBarValue(100);
                setPageCount(Math.ceil(res.data.totalRecords / itemsPerPage));
            } else {
                setData([]);
                toastMessage('error', (res && res.message) || `Unable to load the jobs`);
            }
            setLoading(false);
            setType('');
        }).catch(err => {
            setErrStatus(err?.response?.status);
        });
    };

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(items.slice(itemOffset, endOffset));
        setPageNo(Math.ceil(itemOffset / itemsPerPage) + 1);
        setPageCount(Math.ceil(items.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, items]);



    const handlePageClick = (event) => {
    if (event && event.preventDefault) event.preventDefault();
        const selectedPage = event.selected + 1;
        dispatch(getPageNumber(selectedPage));
        setPageNo(selectedPage);
        setItemOffset((selectedPage - 1) * itemsPerPage);
        setPageNo(selectedPage);
    };


    const handleNotePopupClose = () => {
        setPopupNoteID('');
        setIsReadMore(true);
    }

    const handleClearFilter = () => {
        dispatch(reset());
        setName('');
        setPhoneNumber('');
        setEmail('');
        setApplicationNo('');
        setGender('');
        setSubmittedOn('');
        setUuid('');
        setPaymentStatus('');
        setItemOffset(0);
        setData([]);
        setPageNo(1);
        setPageCount(0);
        setJobId(null);
        setFilterJobId("");
        setProgressBarValue(50);
        setLoading(false);
        setFilterName('');
        setFilterPhoneNumber('');
        setFilterEmail('');
        setFilterApplicationNo('');
        setFilterPaymentStatus('');
        setFilterAppointmentStartDate('');
        setFilterAppointmentEndDate('');
        setFilterSubmittedOnStartDate("");
        setFilterSubmittedOnEndDate("");
        let payload = {
            pageNumber: 1,
            pageSize: itemsPerPage,
            name: '',
            phoneNumber: '',
            email: '',
            applicationNo: '',
            gender: '',
            submittedOn: '',
            uuid: '',
            paymentStatus: '',
            jobId: null,
            appointmentStartDate: '',
            appointmentEndDate: '',
            submittedOnStartDate: '',
            submittedOnEndDate: '',
        };
        eidAppointmentActions.getAllEidAppoinment(payload).then(res => {
            if (res && res.data) {
                setTotalRecords(res?.data?.totalRecords);
                let eidAppointmentData = res.data.data.map((form, index) => ({
                    sno: (pageNo - 1) * itemsPerPage + index + 1,
                    id: form.id,
                    name: form.name,
                    phoneNumber: form.phoneNumber,
                    email: form.email,
                    applicationNo: form.applicationNo,
                    gender: form.gender,
                    submittedOn: form.submittedOn,
                    uuid: form.uuid,
                    paymentStatus: form.payment?.status ?? "-",
                    paymentCompletedDate: form.payment?.completedDate ?? "-",
                    biometricAppointmentDate: form.biometricAppointment?.appointmentDateTime ?? "-",
                    biometricAppointmentStatus: form.biometricAppointment?.status ?? "-",
                    biometricId: form.biometricAppointment?.id ?? "",
                    biometricAppointment: form.biometricAppointment ?? null,
                    jobId: form?.jobId ?? null
                }));
                setData(eidAppointmentData);
                setProgressBarValue(100);
                setPageCount(Math.ceil(res.data.totalRecords / itemsPerPage));
            } else {
                setData([]);
                toastMessage('error', (res && res.message) || `Unable to load the jobs`);
            }
            setLoading(false);
            setType('');
        }).catch(err => {
            setErrStatus(err?.response?.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
    }

    useEffect(() => {
        if (userData.Role === 'SUBADMIN') {
            let status = statusList.filter(({ value }) => value === 'AssignedToTypingCenter' || value === 'AwaitingResponse' || value === 'RequestCancellation' || value === 'RequestCompletion');
            const temp = status.map(({ value, lable }) => ({ value, label: lable }));
            setJobStatusMultipleOptions(temp);
        } else {
            const temp = statusList.map(({ value, lable }) => ({ value, label: lable }));
            setJobStatusMultipleOptions(temp);
        }
    }, [statusList]);

    const filterHandler = () => {
        setLoading(true);
        setProgressBarValue(50);
        if (pageNumber || pageSize || name || phoneNumber || email || applicationNo || gender || submittedOn || uuid || paymentStatus || jobId || appointmentEndDate || appointmentEndDate || submittedOnStartDate || submittedOnEndDate) {
            dispatch(getClearFilterFlag(clearFilterFlag + 1));
        }

        if (!pageNumber && !pageSize && !name && !phoneNumber && !email && !applicationNo && !gender && !submittedOn && !uuid && !paymentStatus && !jobId || !appointmentEndDate && !appointmentEndDate && !submittedOnStartDate && !submittedOnEndDate) {
            dispatch(getClearFilterFlag(clearFilterFlag + 1));
        }
        if(filterSubmittedOnStartDate && !filterSubmittedOnEndDate)
        {
            toastMessage("error", "Please select end date for submitted filter");
            return;
        }
        if(filterAppointmentStartDate && !filterAppointmentEndDate)
        {
            toastMessage("error", "Please select end date for appointment date filter");
            return;
        }
        setName(filterName);
        setPhoneNumber(filterPhoneNumber);
        setEmail(filterEmail);
        setAppointmentStartDate(filterAppointmentStartDate);
        setAppointmentEndDate(filterAppointmentEndDate);
        setSubmittedOnStartDate(filterSubmittedOnStartDate);
        setSubmittedOnEndDate(filterSubmittedOnEndDate);
        setApplicationNo(filterApplicationNo);
        setPaymentStatus(filterPaymentStatus);
        setJobId(filterJobId);
        setPageNo(1);
        setItemOffset(0);
        setPageCount(0);
        setData([]);
        
        itemsPerPage = 10;
        let payload = {
            pageNumber: 1,
            pageSize: itemsPerPage,
            name: filterName || '',
            phoneNumber: filterPhoneNumber || '',
            email: filterEmail || '',
            applicationNo: filterApplicationNo || '',
            gender: gender || '',
            submittedOn: submittedOn || '',
            uuid: uuid || '',
            paymentStatus: filterPaymentStatus ? filterPaymentStatus : '',
            jobId: filterJobId || null,
            appointmentStartDate: filterAppointmentStartDate || '',
            appointmentEndDate: filterAppointmentEndDate || '',
            submittedOnStartDate: filterSubmittedOnStartDate || '',
            submittedOnEndDate: filterSubmittedOnEndDate || '',
        };
        eidAppointmentActions.getAllEidAppoinment(payload).then(res => {
            if (res && res.data) {
                setTotalRecords(res?.data?.totalRecords);
                let eidAppointmentData = res.data.data.map((form, index) => ({
                    sno: (pageNo - 1) * itemsPerPage + index + 1,
                    id: form.id,
                    name: form.name,
                    phoneNumber: form.phoneNumber,
                    email: form.email,
                    applicationNo: form.applicationNo,
                    gender: form.gender,
                    submittedOn: form.submittedOn,
                    uuid: form.uuid,
                    paymentStatus: form.payment?.status ?? "-",
                    paymentCompletedDate: form.payment?.completedDate ?? "-",
                    biometricAppointmentDate: form.biometricAppointment?.appointmentDateTime ?? "-",
                    biometricAppointmentStatus: form.biometricAppointment?.status ?? "-",
                    biometricId: form.biometricAppointment?.id ?? "",
                    biometricAppointment: form.biometricAppointment ?? null,
                    jobId: form?.jobId ?? null
                }));
                setData(eidAppointmentData);
                setProgressBarValue(100);
                setPageCount(Math.ceil(res.data.totalRecords / itemsPerPage));
            } else {
                setData([]);
                toastMessage('error', (res && res.message) || `Unable to load the jobs`);
                setLoading(false);
            }
            setLoading(false);
            setType('');
        }).catch(err => {
            setErrStatus(err?.response?.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
    };

    if (errStatus === 400) {
        return <Warning history={history} />
    }

    function getAllAppointmentDetailsDownloadDatas() {
        setLoadingCsv(true);
        let payload = {
            name: name || '',
            phoneNumber: phoneNumber || '',
            email: email || '',
            applicationNo: applicationNo || '',
            paymentStatus: paymentStatus ? paymentStatus : '',
            jobId: jobId || null,
            appointmentStartDate: appointmentStartDate || '',
            appointmentEndDate: appointmentEndDate || '',
            submittedOnStartDate: submittedOnStartDate || '',
            submittedOnEndDate: submittedOnEndDate || '',
        };
        eidAppointmentActions.exportCsv(payload).then((res) => {
            try {
                toastMessage('info', `Download in progress`);
                var blob = new Blob(["\ufeff", res.data]);
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                var fileName = 'EicAppointmentDetails.csv';
                link.download = fileName;
                link.click();
            } catch (error) {
                console.log('err', error)
                toastMessage('error', "Something went wrong during file download!!");
            }
            setLoadingCsv(false);
        }).catch((err) => {
            setLoadingCsv(false);
            toastMessage('error', "Something went wrong during file download!!");
        })
    }

    const handleBiometricStatusUpdate = (biometricId, status) => {
        setSelectedBiometricId(biometricId);
        setBiometricStatus(status);
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
        setSelectedBiometricId(null);
        setBiometricStatus('');
    };
    const handleBiometricConfirmClose = () => {
        setShowBiometricConfirmModal(false);
        setSelectedBiometricId(null);
        setBiometricStatus('');
    };

    const handleStatusUpdateSubmit = () => {
        setShowModal(false);
        setShowBiometricConfirmModal(true);
    }

    const handleBiometricConfirmSubmit = () => {
        if (!biometricStatus) {
            toastMessage('error', 'Please select a status');
            return;
        } else if (!selectedBiometricId && biometricStatus == "-") {
            toastMessage("error", "appointment not found");
            return;
        }
        setLoading(true);
        eidAppointmentActions.biometricAppointmentStatusUpdate({ id: selectedBiometricId, status: biometricStatus }).then(res => {
            if (res && res.data) {
                toastMessage('success', 'Biometric status updated successfully');
                handleGetAllEidAppointment();
                handleModalClose();
                setShowBiometricConfirmModal(false);
                handleBiometricConfirmClose();
            } else {
                toastMessage('error', res?.message || 'Failed to update biometric status');
                setShowBiometricConfirmModal(false);
                handleBiometricConfirmClose();
            }
            setLoading(false);
        }).catch(err => {
            setLoading(false);
            setShowBiometricConfirmModal(false);
            handleBiometricConfirmClose();
            toastMessage('error', 'Failed to update biometric status');
        });
    };


    const handlePaymentLink = (id, email) => {
        if (!id) {
            toastMessage("error", "Appointment Id is not found");
            return;
        }
        setRowMail(email);
        setSelectedPaymentId(id);
        setShowPaymentConfirmModal(true);
    };

    const handlePaymentConfirmClose = () => {
        setIsAlterMail(false);
        setAlterMail("");
        setShowPaymentConfirmModal(false);
        setSelectedPaymentId(null);
    };

    const handlePaymentConfirmSubmit = () => {
        if (isAlterMail == true) {
            if (!alterMail || alterMail.trim() === "") {
                toastMessage("error", "Alternate email is required.");
                return;
            }
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(alterMail)) {
                toastMessage("error", "Please enter a valid alternate email address.");
                return;
            }
        }
        setPaymentLinkLoaderId(selectedPaymentId);
        eidAppointmentActions.paymentResendMail({ id: selectedPaymentId, isAltermail: isAlterMail, altermail: isAlterMail == true ? alterMail : null }).then(res => {
            if (res && res.data) {
                toastMessage('success', "Payment Link Resend Successfully");
                setAlterMail("");
                setIsAlterMail(false);
            } else {
                toastMessage('error', res?.message || "Payment Link Resend Failed");
                setAlterMail("");
                setIsAlterMail(false);
            }
            setPaymentLinkLoaderId(null);
            handlePaymentConfirmClose();
        }).catch(err => {
            toastMessage("error", "Payment Link Resend Failed");
            setAlterMail("");
            setIsAlterMail(false);
            setPaymentLinkLoaderId(null);
            handlePaymentConfirmClose();
        });
    };


    const handleNote = (id) => {
        setSelectedNoteId(id);
        setShowNoteModal(true);
    };

    

    const downloadBiometricReceipt = async (applicationNo, jobId) => {
        setLoadingReceiptDownload(true);
        try {
            let res = await eidAppointmentActions.biometricReceiptDownload(applicationNo, null);
            if (res.data.value == "No completed payment found for this appointment.") {
                res = await eidAppointmentActions.biometricReceiptDownload(null, jobId);
            }
            let binary_string = window.atob(res.data.fileContents);
            let len = binary_string.length;
            let bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }
            let blob = new Blob([bytes], { type: res.data.contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            let fileName = res.data.fileDownloadName || 'biometric_receipt.pdf';
            link.download = fileName;
            link.click();
            toastMessage('success', 'Biometric receipt downloaded successfully');
        } catch (err) {
            toastMessage('error', 'Failed to download biometric receipt');
            setLoadingReceiptDownload(false);
        }
        setLoadingReceiptDownload(false);
    };

    return (
        <>
            {(type === '') && <div className="container-fluid">
                <div className="page-title-box">
                    <h4 className="page-title my-2">{t("eidAppointmentDetails.title")}</h4>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-xxl-12">
                        <div className="card card-custom card-stretch gutter-b">
                            <div className="card-body py-3">
                                <div className="tab-content">
                                    <div className='d-flex'>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className='mb-1 ms-1 me-3'>
                                                {t("eidAppointmentDetails.filters.submittedStartDate")}
                                            </label>
                                            <DatePicker
                                                className="form-control form-control-sm"
                                                value={filterSubmittedOnStartDate ? dayjs(filterSubmittedOnStartDate, "YYYY-MM-DD") : null}
                                                onChange={(date) => {
                                                    if (!date) return;
                                                    const formattedDate = date.format("YYYY-MM-DD");
                                                    setFilterSubmittedOnStartDate(formattedDate);
                                                    dispatch(getSubmittedOnStartDate(formattedDate));
                                                }}
                                                format="DD-MM-YYYY"
                                                disabledDate={(current) => filterSubmittedOnEndDate ? current && current > dayjs(filterSubmittedOnEndDate, "YYYY-MM-DD") : false}
                                            />
                                        </div>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className='mb-1 ms-1 me-3'>
                                                {t("eidAppointmentDetails.filters.submittedEndDate")}
                                            </label>
                                            <DatePicker
                                                className="form-control form-control-sm"
                                                value={filterSubmittedOnEndDate ? dayjs(filterSubmittedOnEndDate, "YYYY-MM-DD") : null}
                                                onChange={(date) => {
                                                    if (!date) return;
                                                    const formattedDate = date.format("YYYY-MM-DD");
                                                    setFilterSubmittedOnEndDate(formattedDate);
                                                    dispatch(getSubmittedOnEndDate(formattedDate));
                                                }}
                                                format="DD-MM-YYYY"
                                                disabledDate={(current) => filterSubmittedOnStartDate ? current && current < dayjs(filterSubmittedOnStartDate, "YYYY-MM-DD") : false}
                                            />
                                        </div>

                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className='mb-1 ms-1 me-3'>
                                                {t("eidAppointmentDetails.filters.appointmentStartDate")}
                                            </label>
                                            <DatePicker
                                                className="form-control form-control-sm"
                                                value={filterAppointmentStartDate ? dayjs(filterAppointmentStartDate, "YYYY-MM-DD") : null}
                                                onChange={(date) => {
                                                    if (!date) return;
                                                    const formattedDate = date.format("YYYY-MM-DD");
                                                    setFilterAppointmentStartDate(formattedDate);
                                                    dispatch(getAppointmentStartDate(formattedDate));
                                                }}
                                                format="DD-MM-YYYY"
                                                disabledDate={(current) => filterAppointmentEndDate ? current && current > dayjs(filterAppointmentEndDate, "YYYY-MM-DD") : false}
                                            />
                                        </div>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className='mb-1 ms-1 me-3'>
                                                {t("eidAppointmentDetails.filters.appointmentEndDate")}
                                            </label>
                                            <DatePicker
                                                className="form-control form-control-sm"
                                                value={filterAppointmentEndDate ? dayjs(filterAppointmentEndDate, "YYYY-MM-DD") : null}
                                                onChange={(date) => {
                                                    if (!date) return;
                                                    const formattedDate = date.format("YYYY-MM-DD");
                                                    setFilterAppointmentEndDate(formattedDate);
                                                    dispatch(getAppointmentEndDate(formattedDate));
                                                }}
                                                format="DD-MM-YYYY"
                                                disabledDate={(current) => filterAppointmentStartDate ? current && current < dayjs(filterAppointmentStartDate, "YYYY-MM-DD") : false}
                                            />
                                        </div>
                                    </div>
                                    <div className='d-flex mt-2'>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className='mb-1 ms-1 me-3'>{t("eidAppointmentDetails.filters.labelName")}</label>
                                            <input placeholder={t("eidAppointmentDetails.filters.enterName")} type="text" className="form-control me-3" name="name" value={filterName} onChange={(e) => { setFilterName(e.target.value); dispatch(getName(e.target.value)) }} />
                                        </div>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className='mb-1 ms-1 me-3'>{t("eidAppointmentDetails.filters.labelPhoneNumber")}</label>
                                            <input placeholder={t("eidAppointmentDetails.filters.enterPhoneNumber")} type="text" className="form-control me-3" name="Phone Number" value={filterPhoneNumber} onChange={(e) => { setFilterPhoneNumber(e.target.value); dispatch(getPhoneNumber(e.target.value)) }} />
                                        </div>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className='mb-1 ms-1 me-3'>{t("eidAppointmentDetails.filters.labelEmail")}</label>
                                            <input placeholder={t("eidAppointmentDetails.filters.enterEmail")} type="text" className="form-control me-3" name="Email" value={filterEmail} onChange={(e) => { setFilterEmail(e.target.value); dispatch(getEmail(e.target.value)) }} />
                                        </div>
                                    </div>
                                    <div className='d-flex mt-2'>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className='mb-1 ms-1 me-3'>{t("eidAppointmentDetails.filters.labelJobId")}</label>
                                            <input placeholder={t("eidAppointmentDetails.filters.enterJobId")} type="number" className="form-control me-3" name="jobId" value={filterJobId} onChange={(e) => { setFilterJobId(e.target.value); dispatch(getJobId(e.target.value)) }} />
                                        </div>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className='mb-1 ms-1 me-3'>{t("eidAppointmentDetails.filters.labelApplicationNo")}</label>
                                            <input placeholder={t("eidAppointmentDetails.filters.enterApplicationNo")} type="text" className="form-control me-3" name="Application No" value={filterApplicationNo} onChange={(e) => { setFilterApplicationNo(e.target.value); dispatch(getApplicationNo(e.target.value)) }} />
                                        </div>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className='mb-1 ms-1 me-3'>{t("eidAppointmentDetails.filters.labelPaymentStatus")}</label>
                                            <select className="form-select me-3" name="Payment Status" value={filterPaymentStatus} onChange={(e) => { setFilterPaymentStatus(e.target.value); dispatch(getPaymentStatus(e.target.value)) }}>
                                                <option value="" selected >{t("eidAppointmentDetails.filters.all")}</option>
                                                <option value={0}>{t("eidAppointmentDetails.filters.labelPaymentPending")}</option>
                                                <option value={1}>{t("eidAppointmentDetails.filters.labelPaymentCompleted")}</option>
                                                <option value={2}>{t("eidAppointmentDetails.filters.paymentNotFound")}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between mt-3">
                                        <div className="d-flex">
                                            <div className="d-flex align-items-end mb-3" style={{ whiteSpace: 'nowrap' }}>
                                                <button onClick={(e) => { e.preventDefault(); filterHandler(); }} type="button" className="d-flex px-5 align-items-center btn btn-primary font-weight-bold">
                                                    {t("jobsManagement.filters.filter")}
                                                </button>
                                            </div>
                                            <div className="d-flex align-items-end mb-3 ms-3" style={{ whiteSpace: 'nowrap' }}>
                                                <button onClick={(e) => { e.preventDefault(); handleClearFilter(); }} type="button" className="px-5 d-flex align-items-center btn btn-primary font-weight-bold">
                                                    {t("jobsManagement.filters.clearFilters")}
                                                </button>
                                            </div>
                                        </div>
                                        <div className='d-flex align-items-end mb-3' style={{ whiteSpace: 'nowrap', marginRight: "13px" }}>
                                            <button
                                                className='btn btn-primary font-weight-bold d-flex align-items-center'
                                                disabled={loadingCsv}
                                                onClick={getAllAppointmentDetailsDownloadDatas}
                                            >
                                                {t("refunds.export")}
                                                {loadingCsv && (
                                                    <Loader
                                                        type="Oval"
                                                        color="#fff"
                                                        height={20}
                                                        width={20}
                                                        style={{ marginLeft: '5px' }}
                                                    />
                                                )}
                                            </button>
                                        </div>
                                    </div>

                                    {loading ? < Line percent={progressBarValue} strokeWidth={1} strokeColor="#2d207d" trailColor="#b71c1c" />
                                        : <div className="table-responsive mt-4" style={{ width: '100%', overflowX: 'scroll' }}>
                                            <table className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg">
                                                <thead>
                                                    <tr className="text-left" >
                                                        <th className="c-pointer" style={{ width: '75px' }}><span className="text-dark-75">{t("eidAppointmentDetails.manageEidAppointment.sno")}</span></th>
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('jobId')}><span className={(sortConfig && (sortConfig.key === 'jobId')) ? "text-secondary" : "text-dark-75"}>{t("eidAppointmentDetails.manageEidAppointment.jobId")} {(sortConfig && (sortConfig.key === 'jobId')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('name')}><span className={(sortConfig && (sortConfig.key === 'name')) ? "text-secondary" : "text-dark-75"}>{t("eidAppointmentDetails.manageEidAppointment.name")} {(sortConfig && (sortConfig.key === 'name')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th className='c-pointer' style={{ width: '150px' }} onClick={() => requestSort('email')}><span className={(sortConfig && (sortConfig.key === 'email')) ? "text-secondary" : "text-dark-75"}>{t("eidAppointmentDetails.manageEidAppointment.email")} {(sortConfig && (sortConfig.key === 'email')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('phoneNumber')}><span className={(sortConfig && (sortConfig.key === 'phoneNumber')) ? "text-secondary" : "text-dark-75"}>{t("eidAppointmentDetails.manageEidAppointment.phoneNumber")} {(sortConfig && (sortConfig.key === 'phoneNumber')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('applicationNo')}><span className={(sortConfig && (sortConfig.key === 'applicationNo')) ? "text-secondary" : "text-dark-75"}>{t("eidAppointmentDetails.manageEidAppointment.applicationNo")} {(sortConfig && (sortConfig.key === 'applicationNo')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th className='c-pointer' style={{ width: '150px' }} onClick={() => requestSort('paymentStatus')}><span className={(sortConfig && (sortConfig.key === 'paymentStatus')) ? "text-secondary" : "text-dark-75"}>{t("eidAppointmentDetails.manageEidAppointment.paymentStatus")} {(sortConfig && (sortConfig.key === 'paymentStatus')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('paymentCompletedDate')}><span className={(sortConfig && (sortConfig.key === 'paymentCompletedDate')) ? "text-secondary" : "text-dark-75"}>{t("eidAppointmentDetails.manageEidAppointment.paymentCompletedDate")} {(sortConfig && (sortConfig.key === 'paymentcompletedDae')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('biometricAppointmentDate')}><span className={(sortConfig && (sortConfig.key === 'biometricAppointmentDate')) ? "text-secondary" : "text-dark-75"}>{t("eidAppointmentDetails.manageEidAppointment.biometricAppointmentDate")} {(sortConfig && (sortConfig.key === 'biometricAppointmentDate')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('biometricAppointmentStatus')}><span className={(sortConfig && (sortConfig.key === 'biometricAppointmentStatus')) ? "text-secondary" : "text-dark-75"}>{t("eidAppointmentDetails.manageEidAppointment.biometricAppointmentStatus")} {(sortConfig && (sortConfig.key === 'biometricAppointmentStatus')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('gender')}><span className={(sortConfig && (sortConfig.key === 'gender')) ? "text-secondary" : "text-dark-75"}>{t("eidAppointmentDetails.manageEidAppointment.gender")} {(sortConfig && (sortConfig.key === 'gender')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('submittedOn')}><span className={(sortConfig && (sortConfig.key === 'submittedOn')) ? "text-secondary" : "text-dark-75"}>{t("eidAppointmentDetails.manageEidAppointment.submittedOn")} {(sortConfig && (sortConfig.key === 'submittedOn')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th style={{ width: '100px', position: 'sticky', left: '0px', zIndex: '40' }}><span className="text-dark-75">{t("eidAppointmentDetails.manageEidAppointment.action")}</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data.map(({ sno, id, name, phoneNumber, email, applicationNo, gender, submittedOn, paymentStatus, paymentCompletedDate, biometricAppointmentDate, biometricAppointment, biometricAppointmentStatus, biometricId, jobId }) => {
                                                        return (
                                                            <tr key={sno}>
                                                                <td className="pl-7">
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{sno}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{jobId ?? "-"}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{name ?? "-"}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{email ?? "-"}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{phoneNumber ?? "-"}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{applicationNo ?? "-"}</span>
                                                                </td>
                                                                <td className="pl-0 py-8">
                                                                    <Badge
                                                                        className="font-weight-bold badge-pill "
                                                                        bg={paymentStatus === "Payment Completed" ? "success" : paymentStatus === "Pending" ? "danger" : "secondary"}
                                                                    >
                                                                        {paymentStatus === "Payment Completed"
                                                                            ? t("eidAppointmentDetails.filters.labelPaymentCompleted")
                                                                            : paymentStatus === "Pending"
                                                                                ? t("eidAppointmentDetails.filters.labelPaymentPending")
                                                                                : t("eidAppointmentDetails.filters.paymentNotFound")}
                                                                    </Badge>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{paymentCompletedDate ?? "-"}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{biometricAppointmentDate ?? "-"}</span>
                                                                </td>
                                                                <td>
                                                                    <Badge
                                                                        className="font-weight-bold badge-pill "
                                                                        bg={
                                                                            biometricAppointmentStatus === "Completed"
                                                                                ? "success"
                                                                                : biometricAppointmentStatus === "Booking_Confirmed"
                                                                                    ? "primary"
                                                                                    : biometricAppointmentStatus === "Pending"
                                                                                        ? "warning"
                                                                                        : biometricAppointmentStatus === "InProgress"
                                                                                            ? "info"
                                                                                            : biometricAppointmentStatus === 'Cancelled'
                                                                                                ? "danger"
                                                                                                : "secondary"
                                                                        }
                                                                    >
                                                                        {biometricAppointmentStatus === "Completed"
                                                                            ? t("eidAppointmentDetails.filters.completed")
                                                                            : biometricAppointmentStatus === "Pending"
                                                                                ? t("eidAppointmentDetails.filters.pending")
                                                                                : biometricAppointmentStatus === "Cancelled"
                                                                                    ? t("eidAppointmentDetails.filters.cancelled")
                                                                                : biometricAppointmentStatus === "Booking_Confirmed"
                                                                                    ? t("eidAppointmentDetails.filters.bookingConfirmed")
                                                                                : biometricAppointmentStatus === "InProgress"
                                                                                    ? t("eidAppointmentDetails.filters.inProgress")
                                                                                : t("eidAppointmentDetails.filters.notFound")}
                                                                    </Badge>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{gender ?? "-"}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{submittedOn ? submittedOn : '-'}</span>
                                                                </td>
                                                                <td>
                                                                    <Dropdown drop="start">
                                                                        <Dropdown.Toggle variant="info" size="sm" className="font-weight-bolder">
                                                                            <span><BsListTask className="font-20 me-lg-1" /></span>
                                                                        </Dropdown.Toggle>

                                                                        <Dropdown.Menu>
                                                                            {jobId && jobId !== 0 && (
                                                                                <Dropdown.Item
                                                                                    onClick={() =>
                                                                                        ['CALLCENTERSUPPORT', 'FINANCE', 'TRACKING'].includes(userData.Role)
                                                                                            ? history.push(`/customer_job_reports/${jobId}`)
                                                                                            : history.push(`/jobs/${jobId}`)
                                                                                    }
                                                                                    className="d-flex align-items-center gap-2"
                                                                                >
                                                                                    <FaTasks className="text-primary" />
                                                                                    {t("eidAppointmentDetails.manageEidAppointment.manageJobs")}
                                                                                </Dropdown.Item>
                                                                            )}

                                                                            {biometricAppointment !== null && biometricAppointmentStatus !== "Completed" && (
                                                                                <Dropdown.Item
                                                                                    onClick={() => handleBiometricStatusUpdate(biometricId, biometricAppointmentStatus)}
                                                                                    className="d-flex align-items-center gap-2"
                                                                                >
                                                                                    <FaFingerprint className="text-primary" />
                                                                                    {t("eidAppointmentDetails.manageEidAppointment.biometricStatusUpdate")}
                                                                                </Dropdown.Item>
                                                                            )}

                                                                            {paymentStatus !== "Payment Completed" && (
                                                                                <Dropdown.Item
                                                                                    onClick={() => handlePaymentLink(id, email)}
                                                                                    className="d-flex align-items-center gap-2"
                                                                                >
                                                                                    <FaEnvelope className="text-primary" />
                                                                                    {paymentLinkLoaderId === id ? (
                                                                                        <Loader type="Oval" color="#000" height={20} width={20} />
                                                                                    ) : (
                                                                                        t("eidAppointmentDetails.manageEidAppointment.paymentResendMail")
                                                                                    )}
                                                                                </Dropdown.Item>
                                                                            )}

                                                                            {paymentStatus === "Payment Completed" && (
                                                                                <Dropdown.Item
                                                                                    onClick={() => { setSelectedApplicationNo(applicationNo); setSelectedEmail(email); setSelectedJobId(jobId); setShowBiometricReceiptMailModal(true); setReceiptMailSuccess(false); setReceiptMailError(false); setIsAlterMailReceipt(false); setAlterMailReceipt(""); }}
                                                                                    className="d-flex align-items-center gap-2"
                                                                                >
                                                                                    <FaFileAlt className="text-primary" />
                                                                                    {t("eidAppointmentDetails.manageEidAppointment.biometricReceipt")}
                                                                                </Dropdown.Item>
                                                                            )}

                                                                            {userData.Role === "SUPERADMIN" && (
                                                                            <Dropdown.Item
                                                                                onClick={() => history.push(`/eid-appointment-details/edit/${id}`)}
                                                                                className="d-flex align-items-center gap-2"
                                                                            >
                                                                                <FaChevronRight className="text-primary" />
                                                                                {t("eidAppointmentDetails.manageEidAppointment.edit") || 'Edit'}
                                                                            </Dropdown.Item>
                                                                            )}
                                                                            <Dropdown.Item
                                                                                onClick={() => handleNote(id)}
                                                                                className="d-flex align-items-center gap-2"
                                                                            >
                                                                                <FaStickyNote className="text-primary" />
                                                                                {t("eidAppointmentDetails.manageEidAppointment.lableNote")}
                                                                            </Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                            {(pageCount > 1) && <ReactPaginate
                                                breakLabel="..."
                                                nextLabel=">"
                                                previousLabel="<"
                                                onPageChange={handlePageClick}
                                                pageRangeDisplayed={5}
                                                pageCount={pageCount}
                                                forcePage={pageNo - 1}
                                                pageClassName="page-item"
                                                pageLinkClassName="page-link"
                                                previousClassName="page-item"
                                                previousLinkClassName="page-link"
                                                nextClassName="page-item"
                                                nextLinkClassName="page-link"
                                                breakClassName="page-item"
                                                breakLinkClassName="page-link"
                                                containerClassName="pagination"
                                                activeClassName="active"
                                                renderOnZeroPageCount={null}
                                            />}
                                            {(data.length === 0) && <p className="text-center mt-5 mb-5">{t("eidAppointmentDetails.noDataAvailable")}</p>}
                                        </div>}
                                    {data.length > 0 && <DataCountEid itemOffset={itemOffset} items={items} totalRecords={totalRecords} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal show={showModal} onHide={handleModalClose} backdrop="static" clickkeyboard={false} >
                    <Modal.Header >
                        <Modal.Title>{t("eidAppointmentDetails.manageEidAppointment.biometricStatusUpdate")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="biometricStatus">
                                <Form.Label>{t("eidAppointmentDetails.filters.labelBiometricStatus")}</Form.Label>
                                <Form.Select
                                    value={biometricStatus}
                                    onChange={(e) => setBiometricStatus(e.target.value)}
                                >
                                    <option value="" disabled>{t("eidAppointmentDetails.filters.selectStatus")}</option>
                                    <option value="Pending">{t("eidAppointmentDetails.filters.pending")}</option>
                                    <option value="Booking_Confirmed">{t("eidAppointmentDetails.filters.bookingConfirmed")}</option>
                                    <option value="InProgress">{t("eidAppointmentDetails.filters.inProgress")}</option>
                                    <option value="Completed">{t("eidAppointmentDetails.filters.completed")}</option>
                                    <option value="Cancelled">{t("eidAppointmentDetails.filters.cancelled")} </option>
                                </Form.Select>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="info" onClick={handleModalClose}>
                            {t("eidAppointmentDetails.manageEidAppointment.cancel")}
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleStatusUpdateSubmit}
                            disabled={loading}
                        >
                            {loading ? (
                                <Loader type="Oval" color="#fff" height={20} width={20} />
                            ) : (
                                t("eidAppointmentDetails.manageEidAppointment.update")
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
                {showNoteModal && (
                    <NoteModal
                        show={showNoteModal}
                        appointmentId={selectedNoteId}
                        onHide={() => setShowNoteModal(false)}
                    />
                )}

                <Modal show={showBiometricConfirmModal} onHide={handleBiometricConfirmClose} backdrop="static" clickkeyboard={false} >
                    <Modal.Header closeButton>
                        <Modal.Title>{t("eidAppointmentDetails.manageEidAppointment.biometricStatusUpdate")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t("eidAppointmentDetails.manageEidAppointment.confirmBiometricUpdate", { status: biometricStatus })}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="info" onClick={handleBiometricConfirmClose}>
                            {t("eidAppointmentDetails.manageEidAppointment.no")}
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleBiometricConfirmSubmit}
                            disabled={loading}
                        >
                            {loading ? (
                                <Loader type="Oval" color="#fff" height={20} width={20} />
                            ) : (
                                t("eidAppointmentDetails.manageEidAppointment.yes")
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showPaymentConfirmModal} onHide={handlePaymentConfirmClose} backdrop="static" keyboard={false}>
                    <Modal.Header>
                        <Modal.Title>{t("eidAppointmentDetails.manageEidAppointment.paymentResendMail")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>
                            {t("eidAppointmentDetails.manageEidAppointment.confirmPaymentLinkResend")} <strong>{rowMail}</strong>
                        </p>
                        <div className='form-grop'>
                            <Form.Check
                                type="checkbox"
                                id="useAlternateEmail"
                                label={t("eidAppointmentDetails.manageEidAppointment.useAlternateEmail")}
                                checked={isAlterMail}
                                onChange={(e) => setIsAlterMail(e.target.checked)}
                                className="mb-3 mt-2"
                            />
                            {isAlterMail == true && (
                                <Form.Group controlId="alternateEmail">
                                    <Form.Label>{t("eidAppointmentDetails.manageEidAppointment.enterAlternateEmail")}</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="example@example.com"
                                        value={alterMail}
                                        onChange={(e) => setAlterMail(e.target.value)}
                                    />
                                </Form.Group>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="info" onClick={handlePaymentConfirmClose}>
                            {t("eidAppointmentDetails.manageEidAppointment.no")}
                        </Button>
                        <Button
                            variant="primary"
                            onClick={() => handlePaymentConfirmSubmit()}
                            disabled={paymentLinkLoaderId}
                        >
                            {paymentLinkLoaderId ? (
                                <Loader type="Oval" color="#fff" height={20} width={20} />
                            ) : (
                                t("eidAppointmentDetails.manageEidAppointment.yes")
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showBiometricReceiptMailModal} onHide={() => setShowBiometricReceiptMailModal(false)} backdrop="static" keyboard={false}>
                    <Modal.Header>
                        <Modal.Title>{t("eidAppointmentDetails.manageEidAppointment.biometricReceipt")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t("eidAppointmentDetails.manageEidAppointment.confirmBiometricReceiptSendMail")} <strong>{selectedEmail}</strong></p>
                        <div className='form-grop'>
                            <Form.Check
                                type="checkbox"
                                id="useAlternateEmailReceipt"
                                label={t("eidAppointmentDetails.manageEidAppointment.useAlternateEmail")}
                                checked={isAlterMailReceipt}
                                onChange={(e) => {
                                    setIsAlterMailReceipt(e.target.checked);
                                    if (e.target.checked && (!alterMailReceipt || alterMailReceipt.trim() === "")) {
                                        toastMessage("error", "Alternate email is required.");
                                    }
                                }}
                                className="mb-3 mt-2"
                            />
                            {isAlterMailReceipt && (
                                <Form.Group controlId="alternateEmailReceipt">
                                    <Form.Label>{t("eidAppointmentDetails.manageEidAppointment.enterAlternateEmail")}</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="example@example.com"
                                        value={alterMailReceipt}
                                        onChange={(e) => setAlterMailReceipt(e.target.value)}
                                    />
                                </Form.Group>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="info" onClick={() => setShowBiometricReceiptMailModal(false)}>
                            {t("eidAppointmentDetails.manageEidAppointment.close")}
                        </Button>
                        <Button
                            variant="primary"
                            onClick={async () => {
                                if (isAlterMailReceipt && (!alterMailReceipt || alterMailReceipt.trim() === "")) {
                                    toastMessage("error", "Alternate email is required.");
                                    return;
                                }
                                setLoadingReceiptMail(true);
                                setReceiptMailSuccess(false);
                                setReceiptMailError(false);
                                try {
                                    await eidAppointmentActions.biometricReceiptMail({ applicationNo: selectedApplicationNo, isAltermail: isAlterMailReceipt , altermail: isAlterMailReceipt == true  ? alterMailReceipt : null, jobId: selectedJobId });
                                    setReceiptMailSuccess(true);
                                    toastMessage('success', 'Biometric receipt sent successfully');
                                } catch (err) {
                                    setReceiptMailError(true);
                                    toastMessage('error', 'Failed to send biometric receipt');
                                }
                                setLoadingReceiptMail(false);
                            }}
                            disabled={loadingReceiptMail}
                        >
                            {loadingReceiptMail ? (
                                <Loader type="Oval" color="#fff" height={20} width={20} />
                            ) : (
                                t("eidAppointmentDetails.manageEidAppointment.sendMailReceipt")
                            )}
                        </Button>
                        <Button variant="info" onClick={async () => { setLoadingReceiptDownload(true); 
                            try { await downloadBiometricReceipt(selectedApplicationNo, selectedJobId); } finally { setLoadingReceiptDownload(false); } }} disabled={loadingReceiptDownload}>
                            {loadingReceiptDownload ? <Loader type="Oval" color="#fff" height={20} width={20} /> : t("eidAppointmentDetails.manageEidAppointment.downloadReceipt")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>}
        </>
    );
};

export default EidAppointmentDetails;